import httpService from "../httpService";

export default {
  create(form) {
    return httpService.post("/hcCongViecTrongTamCommon", form);
  },

  update(id, form) {
    return httpService.put(`/hcCongViecTrongTamCommon/${id}`, form);
  },

  findById(id) {
    return httpService.get(`/hcCongViecTrongTamCommon/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/congviectrongtam/hcCVTrongTamCommonService.js